import React from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import { toggleQueueAllocationStatus } from './queueAllocationStatuses';

type Props = {
  options: string[];
  value: string[] | null | undefined;
  onChange: (next: string[]) => void;
  tooltipId: string;
};

const QueueAllocationStatusesField: React.FC<Props> = ({ options, value, onChange, tooltipId }) => {
  const selected = Array.isArray(value) ? value : [];

  return (
    <Form.Group className="mb-3">
      <Form.Label>
        Allocation Statuses{' '}
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={tooltipId}>
              Determines which node instance statuses count toward the Queue Limit. Only instances in these statuses occupy a concurrency slot.
              <br />
              <br />
              <strong>Default:</strong> running, started, WorkflowWait, killing.
              <br />
              <br />
              <strong>Note:</strong> selecting &quot;started&quot; also counts the agent &quot;dispatched&quot; phase toward the limit.
              <br />
              <br />
              <strong>Example:</strong> if Queue Limit is 5 and only &quot;running&quot; is selected, up to 5 instances can run simultaneously while
              started/dispatched or waiting instances don&apos;t count toward the limit.
            </Tooltip>
          }
        >
          <span style={{ cursor: 'help', opacity: 0.6, fontSize: '1em' }} title="">
            <FontAwesomeIcon icon={faCircleInfo} />
          </span>
        </OverlayTrigger>
      </Form.Label>
      <div className="border rounded p-2">
        {options.map((s) => {
          const checked = selected.includes(s);
          return (
            <Form.Check
              key={s}
              type="checkbox"
              className="mb-1"
              label={s}
              checked={checked}
              onChange={(e) => onChange(toggleQueueAllocationStatus(selected, s, e.target.checked))}
            />
          );
        })}
      </div>
    </Form.Group>
  );
};

export default QueueAllocationStatusesField;
